<template>
	<transition name="scale">
		<div
			class="customModal fillForm"
			v-show="visible"
			>
			<FormBatch ref="form" @success="getList"/>
			<div class="title">
				<FilterForm v-if="visible" :fields="searchFields" @submit="getList"/>
				<div @click="close" class="operate">
          <i class="fa fa-share fa-2" aria-hidden="true"></i>返回商品列表页
        </div>
			</div>
			<BasicTable
				border
				hasOperate
				hiddenFooter
				customClass="table"
				:tableData="tableData"
				:treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
				:columns="columns" >
			<template slot="tableOpeate">
				批号列表&emsp;
				<AppButton size="small" type="primary" plain @click="add"><i class="fa fa-plus fa-lg icon" ></i>新增</AppButton>
			</template>
			<template v-slot:img="{ item }">
				  <el-image 
						style="width: 100px; height: 100px"
						:src="item.img"
						:preview-src-list="[item.img]" />
				<!-- <img style="width: 50px;height: 50px;" :src="item.img"/> -->
			</template>
			<template v-slot:operate="{ item }">
				<AppButton size="mini" type="primary" plain @click="del(item)">删除批号</AppButton>
				<AppButton size="mini" type="primary" plain @click="edit(item)">编辑批号</AppButton>
			</template>
			</BasicTable>
		</div>
	</transition>
</template>

<script>
import FormBatch from './formBatchNumber.vue';
import { GoodsService } from '../../service/goods.service';
import { MessageBox } from 'element-ui';
const searchFields = [
  { name: '批号名称', key: 'search', type: 'input' },
];
const columns = [
  { name: '产品批号', key: 'batch_no' },
	{ name: '有效期', key: 'expiration_date' },
	{ name: '批次', key: 'batch_sn' },
  { name: '检验报告书', key: 'img', type: 'custom'  },
  { name: '操作', key: 'operate', type: 'custom' },
];
	export default {
		name: 'batchNumber',
		components: { FormBatch },
		data() {
			return {
				visible: false,
				searchFields,
				tableData: [],
				columns,
				goodsData: {},
			}
		},
		methods: {
			async open(data) {
				this.goodsData = data;
				this.getList();
				this.visible = true;
			},
			async getList(data) {
				const result = await GoodsService.getBatchNumber(this.goodsData.goods_id, data);
				this.tableData = result.goods_batch;
			},
			async del(item) {
				await MessageBox.confirm('确定要删除这个批号？');
				await GoodsService.delBatchNumber(item.batch_id).then(()=>{
					this.getList();
				})
			},
			add() {
				this.$refs.form.open(this.goodsData, 'add');
			},
			edit(item) {
				this.$refs.form.open(item, 'edit');
			},
			close() {
				this.visible = false;
			}
		},
	}
</script>

<style lang="scss" scoped>
.title {
	padding: 0;
	margin: 0;
}
</style>